// GENERATED CODE - DO NOT EDIT
export const PriceOverrideReasonMap = {
    ONE_TIME_CASH_PAY: 'ONE_TIME_CASH_PAY',
    VACATION_SUPPLY: 'VACATION_SUPPLY',
    PROGYNY_ZERO_BILL: 'PROGYNY_ZERO_BILL',
};
//# sourceMappingURL=price_override_reason.js.map